import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * AdminEmptyState — unified empty/placeholder state for admin panels.
 *
 * Props:
 *   icon        (FA icon)      — large icon displayed at center
 *   title       (string|null)  — optional heading text
 *   description (string)       — main message text
 *   hint        (string|null)  — optional smaller hint text below description
 *   className   (string)       — additional class name
 */
export default function AdminEmptyState({
  icon,
  title,
  description,
  hint,
  className = '',
  onClick
}) {
  return (
    <div className={`admin-empty-state ${className}`} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      <div className="admin-empty-state-icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      {title && <h4 className="admin-empty-state-title">{title}</h4>}
      <p className="admin-empty-state-description">{description}</p>
      {hint && <small className="admin-empty-state-hint">{hint}</small>}
    </div>
  );
}
